import * as React from "react";
import { Autocomplete as MUIAutocomplete, TextField, Checkbox } from "@mui/material";
import { Controller } from "react-hook-form";

const Autocomplete = ({
  field,
  useFormRef,
  schema,
  options = [],
  groupBy,
  disabled,
  defaultValue,
  onChange: parentOnChange,
  ...props
}) => {
  const { control } = useFormRef;

  const transfOutput = (value) => {
    if (props.multiple) {
      return value ? value.map((val) => val.id) : [];
    } else {
      return value ? value.id : null;
    }
  };

  const transfInput = (value) => {
    if (props.multiple) {
      return value ? options.filter((option) => value.includes(option.id)) : [];
    } else {
      return value ? options.find((option) => option.id === value) : null;
    }
  };

  return (
    <Controller
      name={field}
      control={control}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
        <MUIAutocomplete
          multiple={props.multiple}
          options={options}
          groupBy={groupBy}
          noOptionsText="Sem opções"
          disableCloseOnSelect={props.multiple}
          value={transfInput(value)}
          renderInput={(params) => (
            <TextField
              {...params}
              label={schema?.fields[field]?.spec?.label || "Selecione"}
              required={schema?.fields[field]?.exclusiveTests?.["required"]}
              error={!!error}
              helperText={error?.message}
              onBlur={onBlur}
              inputRef={ref}
            />
          )}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          onChange={(event, selectedOptions) => {
            const transformedValue = transfOutput(selectedOptions);
            onChange(transformedValue);

            if (parentOnChange) {
              parentOnChange(selectedOptions);
            }
          }}
          disabled={disabled}
          {...props}
        />
      )}
    />
  );
}

export default Autocomplete;
